import { useEffect, useRef, useState } from 'react'
import Link from 'next/link'
import { TemplatesResult } from '@/service'
import { RiArrowRightLine } from '@remixicon/react'
import styles from './detail.module.css'

function RelatedCard({ template }: { template: TemplatesResult }) {
  const ref = useRef<HTMLAnchorElement>(null)
  const [visible, setVisible] = useState(false)
  const [imageFailed, setImageFailed] = useState(false)
  const thumbnail = template.Thumb?.[0]?.presignedUrl
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin: '160px' }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])
  return (
    <Link
      ref={ref}
      href={`/templates/${encodeURIComponent(template.Slug.toLowerCase())}`}
      className={styles.relatedCard}
    >
      <div className={styles.relatedVisual} aria-hidden="true">
        {thumbnail && !imageFailed ? (
          <img
            src={thumbnail}
            alt=""
            loading="lazy"
            onError={() => setImageFailed(true)}
          />
        ) : (
          visible && (
            <iframe
              src={template.Embed}
              title={`${template.Title} thumbnail preview`}
              tabIndex={-1}
              loading="lazy"
            />
          )
        )}
      </div>
      <h3>{template.Title}</h3>
      {template.Intro && <p>{template.Intro}</p>}
      <span className={styles.cardLink}>
        View template
        <RiArrowRightLine aria-hidden="true" />
      </span>
    </Link>
  )
}

export function RelatedTemplates({
  templates,
  headingClassName
}: {
  templates: TemplatesResult[]
  headingClassName: string
}) {
  return (
    <section
      className={styles.related}
      aria-labelledby="related-templates-title"
    >
      <h2 id="related-templates-title" className={headingClassName}>
        Find your next starting point.
      </h2>
      <div className={styles.relatedGrid}>
        {templates.map(template => (
          <RelatedCard key={template.id} template={template} />
        ))}
      </div>
    </section>
  )
}
